<template>
  <a
    v-if="href"
    :class="classObject()"
    :href="href"
    :style="{ maxWidth: `${width}px` }"
    :target="extra ? '_blank' : ''"
    :rel="extra ? 'nofollow noopener noreferrer' : ''"
  >
    <span class="button-theme__name">{{ name }}</span>
  </a>
  <button
    v-else
    :class="classObject()"
    :style="{ maxWidth: `${width}px` }"
    :type="type"
    role="button"
    :aria-label="label"
    @click="handleClick"
  >
    <span class="button-theme__name">{{ name }}</span>
  </button>
</template>

<script>
export default {
  name: 'buttonTheme',
  components: {},
  props: {
    mode: String,
    size: String,
    width: Number,
    href: String,
    extra: Boolean,
    name: String,
    type: String,
    label: String,
    isDisabled: Boolean,
  },
  data() {
    return {
      isActive: false,
    };
  },
  computed: {},
  methods: {
    classObject() {
      return {
        'button-theme': true,
        'button-theme--xs': this.size === 'xs',
        'button-theme--s': this.size === 's',
        'button-theme--m': this.size === 'm',
        'button-theme--transparent': this.mode === 'transparent',
        'button-theme--fill': this.mode === 'fill',
        'is-disabled': this.isDisabled,
      };
    },
    handleClick(event) {
      this.$emit('handleClick', event);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

.button-theme {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: $f-neutraBold;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  border: 1px solid $c-black;
  overflow: hidden;
  cursor: pointer;
  @include anim(color, 1.4s, cubic-bezier(0.075, 0.82, 0.165, 1));

  @include hover {
    &::before {
      opacity: 1;
    }
  }

  &::before {
    @include pseudo();
    top: 0;
    left: -1px;
    z-index: 1;
    width: calc(100% + 2px);
    height: 100%;
    opacity: 0;
    @include anim(opacity, 1.4s, cubic-bezier(0.075, 0.82, 0.165, 1));
  }

  & > * {
    pointer-events: none;
  }

  &.is-disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &--xs {
    max-width: max-content;
    height: 24px;

    @include up-tablet {
      height: 31.53px;
    }

    .button-theme__name {
      padding: 0 18px;

      @include up-tablet {
        padding: 0 24px;
      }
    }
  }

  &--s {
    padding: 14px 14px 12px;
    height: 38px;
  }

  &--m {
    padding: 18px 18px 16px;
    height: 46px;
  }

  &--transparent {
    color: $c-black;
    background-color: transparent;

    @include hover {
      color: $c-white;
    }

    &::before {
      background-color: $c-black;
    }
  }

  &--fill {
    color: $c-white;
    background-color: $c-black;

    @include hover {
      color: $c-black;
    }

    &::before {
      background-color: $c-white;
    }
  }

  span {
    position: relative;
    z-index: 2;
    color: currentColor;
  }
}
</style>
